<script setup lang="ts">
defineOptions({
  name: 'UkkoPlusIcon'
})
</script>

<template>
  <img
    :src="require('@/assets/images/features/ukko_plus.svg')"
    alt="Ukko Plus logo"
  />
</template>
